import z from "zod";
import type { Enums } from "../../types/database.types";

export const emailPreferencesSchema = z.object({
	c: z.string(),
});

/**
 * Every `email_type` the database knows, as its enum spells them. A mail of any of them carries
 * the unsubscribe link, so the link's context accepts every one.
 */
export const emailTypes = [
	"partner-report",
	"substitution-external-note",
	"substitution-done-external-note",
	"substitution-internal-note",
	"substitution-done-internal-note",
	"verify-email",
	"reset-password",
	"password-email",
	"substitution-team-note",
	"protocol",
	"note-mention",
	"protocol-involvement",
	"order-complete",
	"project-assigned",
	"project-number-changed",
	"incoming-invoice-review-requested",
	"incoming-invoice-review-decided",
	"partnership-requested",
	"partnership-activated",
	"partnership-deactivated",
] as const satisfies ReadonlyArray<Enums<"emailType">>;

/** Fails to compile when the enum gains a value the list above does not carry. */
type MissingEmailTypes = Exclude<Enums<"emailType">, (typeof emailTypes)[number]>;
const everyEmailTypeListed: [MissingEmailTypes] extends [never] ? true : MissingEmailTypes = true;
void everyEmailTypeListed;

/**
 * What the unsubscribe link's encrypted `c` parameter decrypts to: the mail it came from, the
 * address it went to and the organisation that sent it.
 */
export const decryptedEmailPreferencesContextSchema = z.object({
	type: z.enum(emailTypes),
	email: z.string(),
	orgId: z.string(),
});

export type EmailPreferencesSchema = z.infer<typeof emailPreferencesSchema>;
export type DecryptedEmailPreferencesContextSchema = z.infer<
	typeof decryptedEmailPreferencesContextSchema
>;
